<script>
import PhotoGallery from '@components/photos/photo-gallery.vue';
import { trainerComputed, authComputed, trainerMethods } from '@state/helpers';
import cloneDeep from 'lodash/cloneDeep';
import groupBy from 'lodash/groupBy';
import moment from 'moment';

export default {
  page: {
    title: 'Client Photos',
    meta: [{ name: 'description', content: 'The Client Photos view.' }],
  },
  props: {
    client: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      loadingActivityData: false,
    };
  },
  components: {
    PhotoGallery,
  },
  async beforeMount() {
    this.loadingActivityData = true;
    if (
      !this.clientActivity ||
      !(
        this.client &&
        this.clientActivity &&
        this.client._id === this.clientActivity.client._id
      )
    ) {
      const lastMondaysDate = moment()
        .startOf('isoWeek')
        .format('YYYY/MM/DD');
      const activityPayload = {
        trainerId: this.trainerId,
        userId: this.client._id,
        mondaysDate: lastMondaysDate,
        trainerToken: this.currentUser.trainerToken,
      };
      try {
        await this.getClientActivity(activityPayload);
      } catch (e) {
        console.log(e);
      }
    }
    this.loadingActivityData = false;
  },
  computed: {
    ...trainerComputed,
    ...authComputed,
    clientCheckIns() {
      return (
        this.clientActivity &&
        this.clientActivity.checkIns.length > 0 &&
        this.clientActivity.checkIns
      );
    },
    groupedMonth() {
      const nonSortedCheckIns = cloneDeep(this.clientCheckIns);
      const sortedCheckIns = nonSortedCheckIns.sort(function(a, b) {
        if (a && a.completionDate && b && b.completionDate) {
          if (moment(a.completionDate).isAfter(b.completionDate)) {
            return -1;
          }
          if (moment(b.completionDate).isAfter(a.completionDate)) {
            return 1;
          }
        }
        return 0;
      });
      const groupedItems = groupBy(sortedCheckIns, (checkin) =>
        moment(checkin.completionDate)
          .startOf('month')
          .toISOString()
      );
      return Object.values(groupedItems);
    },
  },
  methods: {
    ...trainerMethods,
  },
};
</script>

<template>
  <div>
    <div v-if="clientCheckIns && !loadingActivityData">
      <div v-for="(month, i) in groupedMonth" :key="month + i">
        <PhotoGallery :month="month" />
      </div>
    </div>
    <div
      v-if="!clientCheckIns && !loadingActivityData"
      class="empty-message--large"
    >
      <h1
        ><strong>{{ client.profile.firstName }}</strong> hasn't taken any photos
        yet. They will be here once they do.</h1
      >
    </div>
    <div class="loading-wrapper" v-if="loadingActivityData">
      <BaseLoadingSpinner />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
.no-photos {
  height: 20rem;
  padding-top: 3rem;
}

.loading-wrapper {
  align-items: center;
  display: flex;
  height: calc(100vh - 15.6rem);
  justify-content: center;
  margin-bottom: auto;
  margin-top: auto;
  width: 100%;
  z-index: 100;
}
</style>
